module.exports = __webpack_public_path__ + "static/media/university_of_minnesota.3304f53c.png";